import {
  IWatchLoadRequest,
  IAddWatchLoad,
  IRemoveWatchLoad
} from '../../schemas/Home/Home.schema';
import { setObject, getObject } from '../../utils/common';
import { load } from './Loads.model';
export class WatchedLoadModel implements IWatchLoadRequest {
  userId?: string = '';
  carrierId?: string = '';
  page?: number = 0;
  size?: number = 10;
  sortColumn?: string = 'pickupDate';
  sortDirection?: string = 'asc';
  managedEquipmentCapability?: string | null = '';
  nonManagedEquipmentCapability?: string | null = '';
  userRole: string = '';
  loadId?: string;

  setofflineWatchedLoads(_loads: []) {
    return setObject('Carrier-offline-Watched-Loads', _loads);
  }

  getofflineWatchedLoads() {
    return getObject('Carrier-offline-Watched-Loads');
  }
 
  addWatchLoad(data: IAddWatchLoad) {
    return {
      mutation: {
        newUserWatchedLoads: {
          __args: {
            input: data
          },
          id: true
        }
      }
    };
  }

  removeWatchLoad(data: IRemoveWatchLoad) {
    return {
      mutation: {
        deleteUserWatchedLoads: {
          __args: {
            input: data
          }
        }
      }
    };
  }

  getRequestPayload() {
    const excludePRoperty = [ "loadId" ];
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function" && !excludePRoperty.includes(key)) input[key] = value;
    }
    const {similarLoads, ...updatedLoad} = load;
    return {
      query: {
        getUserWatchedLoads: {
          __args: {
            input
          },
          totalRecords: true,
          loadPostings: {
            ...updatedLoad,
            exclusiveLoad: true,
            managedEquipment: true
          }
        }
      }
    };
  }
}
